import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { getRegions, getDistricts, geteventCategories } from '../../../../../Redux/Actions/CommonActions';
import { auth } from '../../../../../services';

class EventsFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            region: { name: 'All' },
            district: { name: 'All' },
            eventCategory: { name: 'All' },
            EventCategoryId: null,
            RegionId: null,
            DistrictId: null,
            UserId: null,
            CountyID: 0
        }
    }

    componentDidMount() {
        var userId = auth.getAuthUserId();

        this.props.geteventCategories(userId);
        this.props.getRegions(userId);

        this.setState({
            UserId: userId
        })
    }

    handleCategoryChange = (event) => {
        this.setState({
            EventCategoryId: event.target.value.id,
            eventCategory: event.target.value
        }, () => this.props.updateEvents(this.state));
    }

    handleRegionChange = (event) => {
        this.props.getDistricts(event.target.value.id);
        this.setState({
            RegionId: event.target.value.id,
            region: event.target.value
        }, () => this.props.updateEvents(this.state));
    }

    handleDistrictChange = (event) => {
        this.setState({
            DistrictId: event.target.value.id,
            district: event.target.value
        }, () => this.props.updateEvents(this.state));
    }

    render() {
        return (
            <div className="eventsFilter">
                <div className="container">
                    <div className="row">
                    <div className="col-md-6 col-lg-3">
                        <p className="filterTitle">Category: </p>
                        <DropDownList
                            data={[{ name: "All" }, ...this.props.common.eventCategories]}
                            textField="name"
                            dataItemKey="id"
                            value={this.state.eventCategory}
                            defaultItem={{ name: 'All' }}
                            onChange={this.handleCategoryChange}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <p className="filterTitle">Region: </p>
                        <DropDownList
                            data={[{ name: "All" }, ...this.props.common.regions]}
                            textField="name"
                            dataItemKey="id"
                            value={this.state.region}
                            defaultItem={{ name: 'All' }}
                            onChange={this.handleRegionChange}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <p className="filterTitle">District: </p>
                        <DropDownList
                            data={[{ name: "All" }, ...this.props.common.districts]}
                            textField="name"
                            dataItemKey="id"
                            value={this.state.district}
                            defaultItem={{ name: 'All' }}
                            onChange={this.handleDistrictChange}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                            <button className="eventsFilterBtn" onClick={() => 
                            this.setState({
                                region: { name: 'All' },
                                district: { name: 'All' },
                                eventCategory: { name: 'All' },
                            }, () => this.props.getEvents())}>Reset Filters</button>
                    </div>
                </div>
                    {/* <button className="eventsFilterBtn" onClick={() => this.props.updateEvents(this.state)}>Filter</button> */}
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        authentication: state.authentication,
        common: state.common
    }
}

export default connect(mapStateToProps, { getRegions, getDistricts, geteventCategories })(EventsFilter);

